import { Injectable } from '@angular/core';
import {HttpHeaders} from "@angular/common/http";
import {PlayerApi} from "@lbsdk/*";

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {

  constructor(private _playerApi: PlayerApi) { }

  resetPassword = (newPassword: string, accessToken: string) => {
    const customHeaders = function (headers: HttpHeaders) {
      headers.set('Authorization', accessToken);

      return new HttpHeaders({Authorization: accessToken});
    };
    return this._playerApi.setPassword(newPassword, customHeaders);
  }
}
